/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function UlistIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "ulist", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("circle", { cx: 6.5, cy: 7.5, r: 1.5, fill: "currentColor" }),
        React.createElement("circle", { cx: 6.5, cy: 12.5, r: 1.5, fill: "currentColor" }),
        React.createElement("circle", { cx: 6.5, cy: 17.5, r: 1.5, fill: "currentColor" }),
        React.createElement("path", { d: "M10 7.5H19", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M10 12.5H19", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M10 17.5H19", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(UlistIcon);
export default ForwardRef;
//# sourceMappingURL=ulistIcon.js.map